import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard__section"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Manage Your Subscription", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Your subscription is currently "),
  /*#__PURE__*/_createElementVNode("b", null, "active"),
  /*#__PURE__*/_createTextVNode(". Click the button below to enter the billing portal. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Billing Portal ")
const _hoisted_5 = {
  key: 1,
  class: "dashboard__section"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Manage Your Subscription", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Your subscription is currently "),
  /*#__PURE__*/_createElementVNode("b", null, "inactive"),
  /*#__PURE__*/_createTextVNode(". Click the button below to subscribe. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Subscribe ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_ctx.currentOrg?.subscriptionActive)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            loading: _ctx.loading,
            onClick: _ctx.redirectToBillingPortal
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", null, [
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            loading: _ctx.loading,
            onClick: _ctx.redirectToCheckout
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]))
}